import React from "react";
import { QuestionListItem } from "service/question";
import style from "./index.module.scss";

interface ExerciseTopicsButtonsProps {
    data: QuestionListItem[];
    onAdd: () => void;
    onCloneExercise: () => void;
}

export default function ExerciseTopicsButtons({
    data,
    onAdd,
    onCloneExercise
}: ExerciseTopicsButtonsProps) {
    return (
        <div className={style.root}>
            <div className={style.count}>
                共 {data.length !== 0 ? data.length : 0} 题
            </div>

            <div className={style.buttons}>
                <button className={style.add} onClick={onAdd}>
                    添加题目
                </button>
                <button className={style.clone} onClick={onCloneExercise}>
                    复制问卷
                </button>
            </div>
        </div>
    );
}
